import { render, staticRenderFns } from "./ProvinceCityAreaContent.vue?vue&type=template&id=57955945&scoped=true&"
import script from "./ProvinceCityAreaContent.vue?vue&type=script&lang=ts&"
export * from "./ProvinceCityAreaContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57955945",
  null
  
)

export default component.exports